import type { livechatConfig } from '@/types/liveChat';

export const TEST_DEV_LIST = ['dev', 'test'];

export const AES_KEY = 'ecoflow_crm_app0';

export const AES_IV = 'ecoflow_crm_app0';

// 正式live-chat脚本
export const LIVE_CHAT_PROD_CONFIG: livechatConfig = {
    cn: {
        'data-app-id': 'c8b257de-0fbf-4105-976c-acb60192a873',
    },
    de: {
        'data-app-id': '62ffca1e-a21a-4ef4-9ce8-e029447acdec',
    },
    es: {
        'data-app-id': '75b945ab-2466-4f8d-86bb-6f4208d340fd',
    },
    fr: {
        'data-app-id': '876d6441-012e-400f-8e50-51103bffc1da',
    },
    it: {
        'data-app-id': 'da939e8e-cd86-49ac-8283-75789cbeddf0',
    },
    jp: {
        'data-app-id': '75cb5178-4ae2-4195-ad99-7abe1ddef19d',
    },
    ko: {
        'data-app-id': '6b402141-b540-43f8-9a9c-5c640f39163b',
    },
    nl: {
        'data-app-id': '28f1473d-74f2-499e-b7be-854812438e1e',
    },
    ru: {
        'data-app-id': '1d925db4-e677-46f3-8ac1-51d57ef98389',
    },
    uk: {
        'data-app-id': 'e15c20ee-f382-43ac-b7f1-020272ab61c1',
    },
    us: {
        'data-app-id': 'b0613c05-b353-43cb-927e-c89636d62305',
    },
};

// 测试live-chat脚本
export const LIVE_CHAT_TEST_CONFIG: livechatConfig = {
    cn: {
        'data-app-id': '4e46a66e-2aab-42c0-ae86-2632839c28f4',
    },
    de: {
        'data-app-id': '4ceb8316-87c2-4d1e-b21b-d86c8169618c',
    },
    es: {
        'data-app-id': '45c81762-38ab-4569-bc04-8553a92699c0',
    },
    fr: {
        'data-app-id': '13b77ced-7e59-4772-9669-e391c859bdfb',
    },
    it: {
        'data-app-id': '31fa68f8-a4a2-4e63-9113-f8b23557d9a0',
    },
    jp: {
        'data-app-id': '73eb93c1-44af-4486-886c-37fc13e23fa0',
    },
    ko: {
        'data-app-id': 'af45c2b7-c9ef-4aed-9711-5472258f5388',
    },
    nl: {
        'data-app-id': 'd4ba8562-b7da-ed11-a80b-000d3a64d779',
    },
    ru: {
        'data-app-id': 'd62c21f3-5c21-49ce-a37d-51fc83a9d090',
    },
    uk: {
        'data-app-id': '5958c3ce-3f2d-4ebf-a1e6-5935d24103b9',
    },
    us: {
        'data-app-id': '2d6c6cbf-e656-4769-9111-823b1e16e29e',
    },
};

export const TEST_DATA_ORG_ID = 'd4ba8562-b7da-ed11-a80b-000d3a64d779';

export const PROD_DATA_ORG_ID = '9ae05e11-c6d8-ed11-aed0-000d3a64d144';

export const USER_APP_SYSTEM_NAME = 'user_app';

export const PROVIDER_APP_SYSTEM_NAME = 'provider_app';

export const CRM_USER_APP_SYSTEM_NAME = 'App';

export const CRM_PROVIDER_APP_SYSTEM_NAME = 'App_Pro';

export const CRM_SYSTEM_NAME_MAP: Record<string, string> = {
    [USER_APP_SYSTEM_NAME]: CRM_USER_APP_SYSTEM_NAME,
    [PROVIDER_APP_SYSTEM_NAME]: CRM_PROVIDER_APP_SYSTEM_NAME,
};

export const siteConfig = {
    ko: 1,
    de: 2,
    uk: 3,
    ru: 4,
    it: 5,
    jp: 6,
    fr: 7,
    cn: 8,
    us: 9,
    nl: 10,
    es: 11,
};
